﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class ResourceClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getFileName(filename, useFallback, allLocales) {
        return this.client.apiResourcesFilesByFilenameGet(filename, useFallback, allLocales);
    }
    getLocaleFileName(filename, locale, useFallback, allLocales) {
        return this.client.apiResourcesFilesByFilenameLocaleByLocaleGet(filename, locale, useFallback, allLocales);
    }
    getAllResourcesFiles(useFallback, allLocales) {
        return this.client.apiResourcesFilesGet(useFallback, allLocales);
    }
    updateResources(resources) {
        return this.client.apiResourcesPut(resources);
    }
    search(filename, key, maxResults) {
        return this.client.apiResourcesSearchByFilenameByKeyByMaxGet(filename, key, maxResults);
    }
    createLanguage(language) {
        return this.client.apiResourcesLanguagesPost(language);
    }
    getAllAvailableLanguages() {
        return this.client.apiResourcesLanguagesGet();
    }
    getAllInvariantResources() {
        return this.client.apiResourcesInvariantGet();
    }
    getAllResourcesForLocale(locale, fallback) {
        return this.client.apiResourcesLocaleByLocaleGet(locale, fallback);
    }
}
exports.ResourceClient = ResourceClient;
//# sourceMappingURL=ResourceClient.js.map